module.exports = __webpack_public_path__ + "img/emsbanner1.6ee40dc5.png";